import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-page-cardhead',
  templateUrl: './pageheader-card.component.html',
  styleUrls: ['./pageheader-card.component.scss'],
  imports: [],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true
})
export class PageCardheadComponent {
  @Input() PageName: string = '';
  @Input() PageHeadWidth: number = 650;
  @Input() pageWidth: string = '300px';
  @Input() ribbonIdx = true;

  get pageHeaderMaxWidth(): number {
    return typeof this.PageHeadWidth === 'number' && this.PageHeadWidth > 0 ? this.PageHeadWidth : 650;
  }
}
